import { render, staticRenderFns } from "./InvoicesDetail.vue?vue&type=template&id=2cdc4a98"
import script from "./InvoicesDetail.vue?vue&type=script&lang=js"
export * from "./InvoicesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports